import { useAppDispatch, useAppSelector } from 'app/hooks';
import FooterMenu from 'components/Commons/FooterMenu';
import Header from 'components/Commons/Header';
import AuthPage from 'features/auth/pages/AuthPage';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import TransactionModal from 'features/home/components/Modals/TransactionModal';
import { onChangeAuthPage, setShowSubMenu } from 'features/home/homeSlice';
import useUserDetail from 'hooks/useUserDetail';
import React, { useState } from 'react';
import { platformStates } from 'redux/platformSlice';
import PlatformContainer from '../components/PlatformContainer';

interface CasinoPageProps {}

const CasinoPage: React.FunctionComponent<CasinoPageProps> = () => {
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const { isUserLoggedIn } = useUserDetail();
  const dispatch = useAppDispatch();
  const platform = useAppSelector(platformStates);

  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };

  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  // const handleClickGameInMobile = (game: CasinoGameResponseModel) => {
  //   if (window.innerWidth < 1025) {
  //     setGame(game);
  //   }
  // };

  // const handlePlayClickInMobile = async (type: TypePlay, id: string) => {
  //   setIsLoading(true);

  //   const { ok, body } =
  //     type === TypePlay.PLAY ? await gameApi.playGame(id) : await gameApi.playForFun(id);

  //   setIsLoading(false);

  //   if (ok && body && body.url) {
  //     window.open(body.url, '_self');
  //   }
  // };

  return (
    <div className="casino-page relative">
      <i className="version">Version 1.0</i>

      <div className={`body-waraper`}>
        <Header isCasino onShowChangePasswordPage={onShowChangePasswordPage} />
        <div className="casino-container">
          <PlatformContainer />
        </div>
        <FooterMenu
          isUserLogin={isUserLoggedIn}
          isCasino
          onShowChangePasswordPage={onShowChangePasswordPage}
        />
      </div>
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
    </div>
  );
};

export default CasinoPage;
